import { Conta, error99, FormaPagamento, FormaPagamentoAttributes, FormaPagamentoSearchBox, RetAPI } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const FormaPagamentoService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('FormaPagto/Attributes', 'get', { id })
        const attributes: FormaPagamentoAttributes = {
            contas: [],
            formaPagamento: {
                id: 0,
                descricao: '',
                pacrescimo: 0,
                pdesconto: 0,
                ordem: 0,
                vl_minimo: 0,
                tipo: '',
                id_empresa: 0,
                id_conta: 0,
                motivo_exclusao: '',
                id_user_insert: 0,
                id_user_last_update: 0,
                id_user_exclusao: 0,
                dt_cadastro: '',
                dt_last_update: '',
                dh_exclusao: '',
                name_user_insert: '',
                name_user_last_update: '',
                name_user_delete: '',
                numItem: 0,
                valor: 0,
                description: '',
                crediario: 'N',
            }
        }

        if (resp.data) {

            let contas: Conta[] = []

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.fpagto) {

                    attributes.formaPagamento.id = resp.data.fpagto.id
                    attributes.formaPagamento.descricao = resp.data.fpagto.descricao
                    attributes.formaPagamento.pacrescimo = resp.data.fpagto.pacrescimo
                    attributes.formaPagamento.pdesconto = resp.data.fpagto.pdesconto
                    attributes.formaPagamento.ordem = resp.data.fpagto.ordem
                    attributes.formaPagamento.vl_minimo = resp.data.fpagto.vl_minimo
                    attributes.formaPagamento.tipo = resp.data.fpagto.tipo
                    attributes.formaPagamento.id_user_insert = resp.data.fpagto.id_user_insert
                    attributes.formaPagamento.id_user_last_update = resp.data.fpagto.id_user_last_update
                    attributes.formaPagamento.dt_cadastro = resp.data.fpagto.dt_cadastro
                    attributes.formaPagamento.dt_last_update = resp.data.fpagto.dt_last_update
                    attributes.formaPagamento.name_user_insert = resp.data.fpagto.name_user_insert
                    attributes.formaPagamento.name_user_last_update = resp.data.fpagto.name_user_last_update
                    attributes.formaPagamento.description = resp.data.fpagto.descricao
                    attributes.formaPagamento.crediario = resp.data.fpagto.crediario
                    attributes.formaPagamento.id_conta = resp.data.fpagto.id_conta

                }

                if (resp.data.contas) {
                    contas = resp.data.contas.map((item: any) => {
                        return {
                            id: item.id,
                            descricao: item.descricao,
                            description: item.descricao
                        }
                    })

                    attributes.contas = contas
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }

        }

        return {
            error: false,
            data: attributes
        }
    },

    Save: async (formaPagamento: any): Promise<RetAPI> => {

        let id = ''

        if (formaPagamento.id) {
            id = formaPagamento.id.toString()
        }

        const resp = await Api('FormaPagto/Save', 'post', {

            descricao: formaPagamento.descricao,
            pacrescimo: formaPagamento.pacrescimo,
            pdesconto: formaPagamento.pdesconto,
            ordem: formaPagamento.ordem,
            vl_minimo: formaPagamento.vl_minimo,
            tipo: formaPagamento.tipo,
            crediario: formaPagamento.crediario,
            id, idConta: formaPagamento.idConta,
        })


        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field

                }
            }

            return {
                error: false,
                msg: 'Dados da forma de pagamento gravados com sucesso',
                id: resp.data.formaPagto.id,
                data: resp.data,
                dt_cadastro: resp.data.formaPagto.dt_cadastro,
                dt_last_update: resp.data.formaPagto.dt_last_update,
                name_user_insert: resp.data.formaPagto.name_user_insert,
                name_user_last_update: resp.data.formaPagto.name_user_last_update,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }

        }
    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`FormaPagto/Delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {

            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (filterFormPagto: any): Promise<RetAPI> => {

        const resp = await Api('FormaPagto/Filter', 'get', {
            field: filterFormPagto.field,
            filter_type: filterFormPagto.filter_type,
            filter: filterFormPagto.filter
        })
        const formaPagamento: FormaPagamento[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: formaPagamento
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.formas_pagto.map((item: any) => {
                    return formaPagamento.push({
                        id: item.id,
                        descricao: item.descricao,
                        pacrescimo: item.pacrescimo,
                        pdesconto: item.pdesconto,
                        ordem: item.ordem,
                        vl_minimo: item.vl_minimo,
                        tipo: item.tipo,
                        id_empresa: item.id_empresa,
                        id_conta: item.id_conta,
                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        description: item.descricao,
                        crediario: item.crediario
                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: formaPagamento
            }
        }

        return {
            error: false,
            data: formaPagamento
        }

    },

    FilterExcluidas: async (filterFormPagto: any): Promise<RetAPI> => {

        const resp = await Api('FormaPagto/Filter/Excluidas', 'get', {
            datai: filterFormPagto.datai,
            dataf: filterFormPagto.dataf,
            descricao: filterFormPagto.descricao
        })
        const formPgto: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: formPgto
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.forma_pagto.map((item: any) => {
                    return formPgto.push({
                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao,
                        tipo: item.tipo
                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: formPgto
            }
        }

        return {
            error: false,
            data: formPgto,
        }
    },

    GetListFormaPagto: async (): Promise<RetAPI> => {

        const resp = await Api('FormaPagto/List', 'get')
        const formaPagto: FormaPagamentoSearchBox[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: formaPagto
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.forma_pagto.map((item: any) => {
                    return formaPagto.push({

                        id: item.id,
                        description: item.descricao,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: formaPagto
            }
        }

        return {
            error: false,
            data: formaPagto
        }
    },
}
